<script>
    import { onMount } from "svelte";

    export let userDetails = {};
    export let goToSettingsFunc = () => {};

    let displayUser = {};

    onMount(() => {
        displayUser = { ...userDetails };
    });
</script>

<div class="flex flex-col px-4 gap-y-2">
    <div
        class="flex flex-1 items-center justify-between py-2 border-b border-gray-400 sticky top-0 bg-white"
    >
        <p class="font-[700] text-[18px] text-black">Profile Details</p>
        <button
            class="btn btn-secondary"
            on:click|preventDefault={goToSettingsFunc}
        >
            Edit Profile
        </button>
    </div>

    <div class="flex flex-col flex-1 w-full gap-y-4">
        <div class="flex flex-1 items-center">
            <p class="profileTitle">Email</p>
            <p class="profileContent">{displayUser.email}</p>
        </div>

        <div class="flex flex-1 items-center">
            <p class="profileTitle">Full name</p>
            <p class="profileContent">{displayUser.fullName}</p>
        </div>

        <div class="flex flex-1 items-center">
            <p class="profileTitle">Phone</p>
            <p class="profileContent">
                {displayUser.phone ? displayUser.phone : ""}
            </p>
        </div>
    </div>
</div>

<style>
    .profileTitle,
    .profileContent {
        line-height: 2rem;
        cursor: default;
    }

    .profileTitle {
        width: 33%;
        color: gray;
    }

    .profileContent {
        width: 66%;
        color: black;
    }
</style>
